import React, { useState } from 'react';
import './CouponCode.css';

const CouponCode = () => {
    const [copied, setCopied] = useState(false);
    const [hovered, setHovered] = useState(false);
    const couponCode = "FIRM85";

    const copyToClipboard = () => {
        navigator.clipboard.writeText(couponCode)
            .then(() => {
                setCopied(true);
                setTimeout(() => setCopied(false), 2000);
            })
            .catch((err) => {
                console.error('Failed to copy text: ', err);
            });
    };

    return (
        <div className="coupon-container">
            <p className="coupon-text">
                Avail <span className="discount">85% off</span> using this coupon code:
            </p>
            <div
                className="coupon-code"
                onClick={copyToClipboard}
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
            >
                <h3 className="code">{couponCode}</h3>
                {hovered && !copied && <span className="hover-text">Click to Copy</span>}
            </div>

            {copied && <p className="copied-message">Coupon code copied!</p>}
        </div>
    );
};

export default CouponCode;
